import OverviewExportMenu from "./OverviewExportMenu";
import {
  buildSubjectiveOverviewFileBase,
  buildSubjectiveOverviewSheets,
  buildSubjectiveOverviewSingleCsvRows,
} from "./subjectiveOverviewExportUtils";

export default function SubjectiveOverviewExportMenu({ data, isDarkMode = false, disabled = false }) {
  return (
    <OverviewExportMenu
      data={data}
      isDarkMode={isDarkMode}
      disabled={disabled}
      buildSheets={buildSubjectiveOverviewSheets}
      buildSingleCsvRows={buildSubjectiveOverviewSingleCsvRows}
      buildFileBase={buildSubjectiveOverviewFileBase}
      i18nPrefix="export_subjective_overview"
      theme="sky"
    />
  );
}
